import { useCallback } from 'react';
import { publicEventsAPIService } from 'js/services/publicEventsAPI.service';
import { useContinueLoginWithSessionToken } from './useContinueLoginWithSessionToken';
import { useInitialLoginAndSessionValidation } from './useInitialLoginAndSessionValidation';

export const useLoginByCredentials = () => {
    const initialLoginAndSessionValidation = useInitialLoginAndSessionValidation();
    const continueLoginWithSessionToken = useContinueLoginWithSessionToken();

    return useCallback(
        async (userName, password, rememberMeLogin = false, afterRegisterLogin = false, loginMode, fitToPlay = false
    ) => {
        const credentials = await initialLoginAndSessionValidation(
            userName, password, rememberMeLogin, afterRegisterLogin, loginMode, fitToPlay);

        try {
            await continueLoginWithSessionToken({
                ...credentials, afterRegisterLogin, isAfterLoginWithCredentials: true, isLoginToNativeAppEnabled: true
            });
        } catch (error) {
            publicEventsAPIService.trigger('auth:credentials:login:failed', error);

            throw error;
        }
    }, [initialLoginAndSessionValidation, continueLoginWithSessionToken]);
};
